<div class="nim__content">

  <div class="nim__content-area relative">
    <div class="touch-table__wrapper overflow-visible pr2">
      <div class="touch-table__table-wrapper">

        <absg-spinner id="legalDisclaimerSpinner" [show]="showSearchSpinner"></absg-spinner>
        <div class="touch-table width100">

          <div class="flex height100">
            <div class="col-3 bg-white-smoke p3 pt4 border-right border-navy-87">
              <div class="h2">Terms &amp; Conditions</div>
            </div>
            <div class="col-9 p3 pt4 border-radius-tr border-radius-br relative">
              <div id="disclaimerText" [innerHTML]="disclaimerText | async">
              </div>
              <div class="h4 mt2">By logging in you agree that you have read and agree to these terms. To continue select
                “Agree” to indicate your acceptance of these Terms and Conditions. Select “Cancel” if you do not agree and you
                will be returned to the login screen.
              </div>
              <div class="mt2 absolute bottom-2 right-2">
                <button type="button" id="btnCancelLegalDisclaimer" class="btn btn--true-blue-inverse mr2" (click)="onCancelClicked()">Cancel</button>
                <button type="button" id="btnSave" class="btn btn--true-blue" (click)="onSave()" [disabled]="agreeBtnDisabled">I Agree</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


  </div>

  <div class="nim__sidebar">
    <div class="nim__sidebar__top no-padding">
      &nbsp;
    </div>

    <div>
      <div class="nim__sidebar__global">
      </div>

    </div>
  </div>
</div>
